import io from 'socket.io-client'
const debug = false
const url = debug === true ? 'localhost:5000' : 'https://tremus-shopper.delpasystem.com'
let socket = io(url)
export default  socket